(function($){

	$(document).ready(function(){

		$('.bp-slider').each(function(index){

	 		var $prev_item = $(this).siblings('.bp-slider__navigation').find('.slick-prev');
	 		var $next_item = $(this).siblings('.bp-slider__navigation').find('.slick-next');

	 		if(!$(this).hasClass('slick-initialized')) {

	 			$(this).on('init',function(event, slick){
	 				var $slide = $(slick.$slides[0]);
	 				var $slide_title = $slide.data('title');
	 				var $slide_subtitle = $slide.data('subtitle');
	 				$(this).siblings('.bp-slider__navigation').find('.current-slide__info').find('.slide-title').html($slide_title);
	 				$(this).siblings('.bp-slider__navigation').find('.current-slide__info').find('.slide-subtitle').html($slide_subtitle);
	 			}).on('beforeChange',function(event, slick, currentSlide, nextSlide) {
	 				var $slide = $(slick.$slides[currentSlide]);
	 				$(this).siblings('.bp-slider__navigation').find('.current-slide__info').css('opacity',0);
	 			}).on('afterChange',function(event, slick, currentSlide) {
	 				var $slide = $(slick.$slides[currentSlide]);
	 				var $slide_title = $slide.data('title');
	 				var $slide_subtitle = $slide.data('subtitle');
	 				$(this).siblings('.bp-slider__navigation').find('.current-slide__info').find('.slide-title').html($slide_title);
	 				$(this).siblings('.bp-slider__navigation').find('.current-slide__info').find('.slide-subtitle').html($slide_subtitle);
	 				$(this).siblings('.bp-slider__navigation').find('.current-slide__info').css('opacity', 1);
	 			}).slick({
	 				slidesToShow: 5,
	 				slidesToScroll: 1,
	 				arrows: true,
	 				dots: false,
	 				infinite: true,
	 				autoplay: false,
	 				swipe: true,
	 				centerMode: true,
	 				prevArrow: $prev_item,
	 				nextArrow: $next_item,

	 				responsive: [
	 					{
	 						breakpoint: 992,
	 						settings: {
	 							slidesToShow: 3,
	 							slidesToScroll: 1
	 						}
	 					},
	 					{
	 						breakpoint: 768,
	 						settings: {
	 							slidesToShow: 1,
	 							slidesToScroll: 1
	 						}
	 					}
	 				]
	 			});
	 		}

	 	});

	});

})(jQuery);